import customSwiper, {indexNavigation, swiperIndexNav, test} from './modules/swiper/custom-swiper.js'
import customCounter from './modules/counter/custom-counter.js'
import customSearch from './modules/search/custom-search.js'
import firstNav from './modules/menu/custom-menu.js'
import imgZoom from './modules/image-zoom/custom-img-zoom.js'


//swiper
customSwiper();

//Counter
customCounter();

//Suche
customSearch();

//Navigation
firstNav();

//image Zoom
imgZoom();

//Inhaltsnavigation
indexNavigation()


//BackToTop
const toTopBtn = document.getElementById("toTopBtn");

if(toTopBtn){
    window.addEventListener("scroll", () => {
        if (window.scrollY > 300) {
            toTopBtn.classList.add("show");
        } else {
            toTopBtn.classList.remove("show");
        }
    });

    toTopBtn.addEventListener("click", () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });
}

//Sticky Element
const toStickyEle = document.querySelector(".sticky-element");


if(toStickyEle){
	window.addEventListener("scroll", () => {
		if (window.scrollY > 300) {
			toStickyEle.classList.add("show");
		} else {
			toStickyEle.classList.remove("show");
		}
	});
}



//UO-Accessibility
import UoAccessability from "./modules/uo-accessibility/uo-accessibility";

document.addEventListener("DOMContentLoaded", function () {
	const uoAccessability = new UoAccessability({
		overwriteFocusVisibleStyles: true,
        hiddenClass: "uo-accessibility-hidden", // BS >= 5: visually-hidden, BS < 5: sr-only
		helper: [
			{                
				helperName: {
					'de-DE': "Hauptnavigation"
				},
				targetSelector: "header .primary-nav",
				anchorID: "uo-target-nav",
				linkText: {
					'de-DE': "Direkt zur Hauptnavigation"
				}			
			},
			{
				helperName: {
					'de-DE': "Inhalt"
				},
				targetSelector: "main",
				anchorID: "uo-target-content",
				linkText: {
					'de-DE': "Direkt zum Inhalt"
				}
			},
			{
				helperName: {
					'de-DE': "Footer"
				},
				targetSelector: "footer",
				anchorID: "uo-target-footer",
				linkText: {
					'de-DE': "Direkt zum Footer"
				}
			},
		],
	});

});
//UO-Accessibility END


// Scrollspy
document.addEventListener('DOMContentLoaded', () => {
  const indexNav = document.querySelector('#indexNav');
  const body = document.body;

  // Only add attributes if the target element exists
  if (indexNav && body) {
    body.setAttribute('data-bs-spy', 'scroll');
    body.setAttribute('data-bs-target', '#indexNav');
  }
});
// Scrollspy END



// Copy Metanav
document.addEventListener('DOMContentLoaded', () => {
  // Select source and target elements
  const metaNavigation = document.querySelector('header div.meta-navigation');
  const navFirstArea = document.querySelector('ul.nav-first-area');

  // Exit early if required elements are missing
  if (!metaNavigation || !navFirstArea) {
    return;
  }

  // Clone the meta navigation (deep clone)
  const metaNavigationClone = metaNavigation.cloneNode(true);

  // Add additional class only to the clone
  metaNavigationClone.classList.add('meta-nav-copy');

  // Insert the clone directly after nav-first-area
  navFirstArea.insertAdjacentElement('afterend', metaNavigationClone);
});

// Copy Metanav END